import { useState } from 'react'
import { Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ResourceExtendPopUp from './ResourceExtendPopUp'
import moment from 'moment'
import { useExtendComputerSession, useTargetPerson } from 'hooks'
import { useActivateNow } from 'containers/ListingPage/useRequestAccessResources'
import useConfiguration from 'useConfiguration'
import { ItemDetails } from 'components'

const GenericExtendButton = ({ item, style }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const [showExtensionForm, setShowExtensionForm] = useState(false)
    const resource = item.resource ? item.resource : item
    const {
        mutateAsync: extendComputerSession,
        isLoading: isExtendingComputerSession,
    } = useExtendComputerSession()
    const { mutateAsync: activateResource, isLoading: isExtending } =
        useActivateNow()
    const [targetPerson] = useTargetPerson()
    const { getResourceType } = useConfiguration()

    const getExtendConfig = () => {
        switch (resource.resourceTypeName) {
            case 'Computer':
                return {
                    extendSessionMutation: {
                        mutateAsync: extendComputerSession,
                        isLoading: isExtendingComputerSession,
                    },
                    getExtendPayload: (resource, selectedEndDate) => {
                        return {
                            externalCredentialCheckoutId: resource?.checkOutId,
                            endDate: moment.utc(selectedEndDate).format(),
                        }
                    },
                }

            case 'ApplicationRole':
            case 'BusinessRole':
            case 'AzureRole':
            case 'AzLocalRight':
            case 'ManagementRole':
            case 'MailBox':
            case 'SharedFolder':
            case 'AzureLicense': {
                const resourceType = getResourceType(resource.resourceTypeName)

                return {
                    extendSessionMutation: {
                        mutateAsync: activateResource,
                        isLoading: isExtending,
                    },
                    getExtendPayload: (
                        resource,
                        selectedEndDate,
                        resourceAssignmentId,
                    ) => {
                        return resourceType
                            ? {
                                  resourceType: resourceType,
                                  resourceId: resource?.id,
                                  targetPersonPersonId: targetPerson.id,
                                  resourceAssignmentId: resourceAssignmentId,
                                  timeConstraintDetails: {
                                      startDateUtc: moment.utc().format(),
                                      endDateUtc: moment
                                          .utc(selectedEndDate)
                                          .format(),
                                  },
                              }
                            : {}
                    },
                }
            }
            default:
                console.error('Resource Not Extendable')
                return {}
        }
    }

    let extendSessionMutation, getExtendPayload
    if (showExtensionForm) {
        const config = getExtendConfig()
        extendSessionMutation = config.extendSessionMutation
        getExtendPayload = config.getExtendPayload
    }

    return (
        <>
            <ItemDetails.ActionButton
                fontColor={theme?.palette?.common?.white}
                border={`solid 1px ${theme?.palette?.primary?.main}`}
                loaderColor={theme?.palette?.common?.white}
                bgColor={theme?.palette?.primary?.main}
                minWidth="1.2rem"
                width="fit-content"
                lineHeight="1.43"
                height="3.1rem"
                {...style}
                onClick={() => setShowExtensionForm(!showExtensionForm)}
            >
                <Typography
                    style={{
                        color: theme?.palette?.white?.white,
                    }}
                >
                    {t('Common_Extend')}
                </Typography>
            </ItemDetails.ActionButton>

            {showExtensionForm && (
                <ResourceExtendPopUp
                    item={item}
                    handleClose={() => setShowExtensionForm(false)}
                    extendSessionMutation={extendSessionMutation}
                    getExtendPayload={getExtendPayload}
                />
            )}
        </>
    )
}

export default GenericExtendButton
